<template>
  <div class="body">
    <el-tabs :value="activeName">
      <el-tab-pane label="异常信息" name="first">
        <div>
          <table class="ProcessExceptionTable" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">系统编号:</td>
              <td>{{processExceptionVO.billNo}}</td>
              <td class="tableLabel">开单人:</td>
              <td>{{processExceptionVO.creatorName}}</td>
              <td class="tableLabel">登记日期:</td>
              <td>{{processExceptionVO.createTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">反馈部门:</td>
              <td>{{processExceptionVO.feedbackDepart}}</td>
              <td class="tableLabel">反馈人:</td>
              <td>{{processExceptionVO.feedbackPerson}}</td>
              <td class="tableLabel">出厂编号:</td>
              <td>{{processExceptionVO.factoryNo}}</td>
            </tr>
            <tr>
              <td class="tableLabel">客户名称:</td>
              <td>{{processExceptionVO.customerName}}</td>
              <td class="tableLabel">物料号:</td>
              <td>{{processExceptionVO.materialNo}}</td>
              <td class="tableLabel">物料描述:</td>
              <td>{{processExceptionVO.materialName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">当批总数:</td>
              <td>{{processExceptionVO.batchNum}}</td>
              <td class="tableLabel">不良数量:</td>
              <td>{{processExceptionVO.badNum}}</td>
              <td class="tableLabel">误工工时:</td>
              <td>{{processExceptionVO.workTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">一体机/板卡序列号:</td>
              <td colspan="5">{{processExceptionVO.serialNo}}</td>
            </tr>
          </table>
        </div>
        <h1 class="mainTitle" style="font-size: 16px;text-align: left;">问题描述</h1>
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">基准:</td>
            <td>{{processExceptionVO.standards}}</td>
          </tr>
          <tr>
            <td class="tableLabel">实际:</td>
            <td>{{processExceptionVO.problemDesc}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注:</td>
            <td>{{processExceptionVO.note}}</td>
          </tr>
          <tr>
            <td class="tableLabel">是否需要对当前问题处理:</td>
            <td>{{processExceptionVO.isHandle ? "是" : "否"}}</td>
          </tr>
          <tr v-if="processExceptionVO.isHandle">
            <td class="tableLabel">处理部门接口人:</td>
            <td>{{processExceptionVO.handleName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">质量部接口人:</td>
            <td>{{processExceptionVO.qualityDirecterName}}</td>
          </tr>
        </table>
        <div style="padding: 20px 0 10px 10px;width: 90%;margin: 0 auto">
          <div>
            <el-form
                ref="formUplosd"
                enctype="multipart/form-data"
                label-position="right"
                label-width="120px"
                size="mini">
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between">
                <div>
                  <div v-if="!processExceptionVO.accessories || !processExceptionVO.accessories.length">暂无附件</div>
                  <table width="100%">
                    <tr v-for="(item, index) in processExceptionVO.accessories" :key="index">
                      <td>附件{{index + 1}}</td>
                      <td style="cursor: pointer;padding:5px;color: #20a0ff" @click="openFile(item)">
                        {{item.fileName}}
                      </td>
                      <td style="padding:5px"><el-input v-model="item.note" size="mini"/></td>
                      <td style="padding:5px;color: #20a0ff;cursor: pointer;" @click="deleteFile(index)">删除</td>
                    </tr>
                  </table>
                </div>
                <div>
                  <el-upload
                      action=""
                      multiple
                      :http-request="submitUpload"
                      :show-file-list="false"
                      :disabled="uploadLoading"
                      style="display: inline-block; float: right; margin: 5px;">
                    <el-button type="primary" plain>
                      <i class="el-icon-upload el-icon--right"/>
                      附件上传
                    </el-button>
                  </el-upload>
                </div>
              </div>
            </el-form>
          </div>
        </div>

        <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
      </el-tab-pane>
      <el-tab-pane label="处理部门" name="second">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">不合格品处理方式:</td>
            <td>{{processExceptionVO.processMode}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="third" label="质量判责">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">质量判责结果:</td>
            <td>{{processExceptionVO.judgmentResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任部门:</td>
            <td>{{processExceptionVO.responsibleDepartment}}</td>
          </tr>
          <tr>
            <td class="tableLabel">供应商名称:</td>
            <td>{{processExceptionVO.supplierName}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="维修处理结果">
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">检查结果:</td>
            <td>{{processExceptionVO.inspectionResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理方法:</td>
            <td>{{processExceptionVO.solution}}</td>
          </tr>
          <tr>
            <td class="tableLabel">故障模块分类:</td>
            <td>{{processExceptionVO.faultType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电机问题类型:</td>
            <td>{{processExceptionVO.problemType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">原因分析:</td>
            <td>{{processExceptionVO.causeInvestigation}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任判定:</td>
            <td>{{processExceptionVO.responsibleDecision}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constants from "@/util/constants";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "",
    components: {HandleDetail},
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        constants,
        activeName: "first",
        uploadLoading:false,
        processExceptionVO: {
          processExceptionMaterialVOS: [],
          accessories: [],
        },

      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        console.log(this.params);
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `processExceptions/${this.billId}`)
          .then(resp => {
            console.log(resp);
            this.$emit("loading-status", {"loading": false});
            this.processExceptionVO = resp;
          });
      },
      onSelectHandle(row) {
        this.processExceptionVO.handleID = row.systemUserID;
        this.processExceptionVO.handleName = row.employeeName;
      },
      onSelectCountersign(row) {
        this.processExceptionVO.countersignID = row.systemUserID;
        this.processExceptionVO.countersignName = row.employeeName;
      },
      onSelectRework(row) {
        this.processExceptionVO.reworkID = row.systemUserID;
        this.processExceptionVO.reworkName = row.employeeName;
      },
      deleteFile(index) {
        this.processExceptionVO.accessories.splice(index, 1);
      },
      openFile(item) {
        console.log(item);
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + item.filePath;
        a.target = "_blank";
        a.download = item.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      doApprove() {
        //console.log(this.params.countersignVOS);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          approveVar: this.params.approveVar,
          billParam: "",
        };
        console.log(this.params);
        // this.sentWeChat(0,"fanghl");
        this.$emit("loading-status", {"loading": true});
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", {"loading": false});
            //退回到审批人时状态修改到未提交
            if (this.params.actionType ===2 && this.params.untreadedFlowId === "0;submitter") {
              this.updateStatus();
            }
            if (this.params.actionType ===0 && this.params.nodeId === "DealDepartment") {
              //企业微信通知;
              if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
                this.params.applicationVarVOS.forEach(item=>{
                  if (item.varValue === "true" && item.varName === "CountersignComments_ht") {
                    this.sentWeChat(0,"wangtj");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_ds") {
                    this.sentWeChat(0,"liuyf");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_bs") {
                    this.sentWeChat(0,"yuyong");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_cg") {
                    this.sentWeChat(0,"liuym");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_clg") {
                    this.sentWeChat(0,"cailg");
                    setTimeout(1000);
                  }else if (item.varValue === "true" && item.varName === "CountersignComments_cl") {
                    this.sentWeChat(0,"chenlin");
                  }
                });
              }
            }
            this.$message.success("操作成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/ProcessException",
            });
          }).catch(() => {
            this.$emit("loading-status", {"loading": false});
          });
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.processExceptionVO.accessories.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      updateStatus() {
        this.$http
          .get("basic", `processExceptions/updateStatus/${this.processExceptionVO.pkid}`)
          .then(() => {
            this.$message.success("退回到提交人成功！！！");
          });
      },
      sentMessage() {
        let name = "";
        let userId = 0;
        switch (this.params.nodeId) {
          case "DealDepartment":
            console.log("sentMessagesentMessagesentMessagesentMessage");
            console.log(this.params.applicationVarVOS);
            if (this.params.applicationVarVOS.length>0) {
              if (this.params.applicationVarVOS[0].varValue === "特批" && this.params.applicationVarVOS[1].varValue === "true") {
                this.sentWeChat(0,"fanghl");
                // if (this.params.applicationVarVOS[2].varValue === "true") {
                //   // this.sentWeChat(0,"wangtj");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[3].varValue === "true") {
                //   // this.sentWeChat(0,"liuyf");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[4].varValue === "true") {
                //   // this.sentWeChat(0,"yuyong");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[5].varValue === "true") {
                //   // this.sentWeChat(0,"liuym");
                //   this.sentWeChat(0,"fanghl");
                // }
                // if (this.params.applicationVarVOS[6].varValue === "true") {
                //   // this.sentWeChat(0,"cailg");
                //   this.sentWeChat(0,"fanghl");
                // }
              }

            }
            break;
          case "CountersignComments_ht":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_ds":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_bs":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_cg":
            console.log(this.params.applicationVarVOS);
            break;
          case "CountersignComments_clg":
            console.log(this.params.applicationVarVOS);
            break;
          case "Managerriskassessment":
            break;
        }
      },
      sentWeChat(userId,name) {
        let params = {
          userId:userId,
          name:name,
          pkid:this.processExceptionVO.pkid,
          formId:24,
        };
        console.log(params);
        this.$http
          .get("basic", "inspectionInComings/sentWeChat",params)
          .then(() => {
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .body {
    .ProcessExceptionTable {
      width: 100%;
      font-family: verdana, arial, sans-serif;
      font-size: 13px;
      color: #333333;
      border-left: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }
  
    .ProcessExceptionTable1 {
      font-family: verdana, arial, sans-serif;
      font-size: 11px;
      color: #333333;
      border-left: 1px solid #ebeef5;
    }
  
    table.ProcessExceptionTable1 th {
      text-align: left;
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #ebeef5;
      background-color: #f4f7fa;
    }
  
    table.ProcessExceptionTable1 td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #ebeef5;
      border-left: none;
      border-bottom: none;
    }
  
    table.ProcessExceptionTable th {
      text-align: left;
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #ebeef5;
      background-color: #f4f7fa;
    }
  
    table.ProcessExceptionTable td {
      border-width: 1px;
      padding: 8px;
      border-style: solid;
      border-color: #ebeef5;
      border-left: none;
      border-bottom: none;
    }
  
    .tableLabel {
      width: 15%;
      text-align: right;
      background-color: #d1e6f5 !important;
    }

    .title {
      font-size: 12px;
      font-weight: 550;
      border: none;
      border-bottom: 1px solid #ccc;
      width: 100%;
      margin: 5px 0 5px;
      height: 0;
    }
  
    .mainTitle {
      font-size: 20px;
      line-height: 20px;
      text-align: center;
    }
  }
</style>
